//发送是否计算保费
const emit_dic_isNeedCalcPrice = 'onNeedCalcPrice'

//计算保费
const emit_dic_CalcPrice = 'onCalcPrice'

const emit_plan_check = 'emit_plan_check'

export {emit_dic_isNeedCalcPrice, emit_dic_CalcPrice, emit_plan_check}
